<template>
  <div class="searchOnlineSearch">
    <!-- 搜索 -->
    <div class="search_">
      <div class="back" @click.stop="goBack">
        <van-icon name="arrow-left" />
      </div>
      <van-search
        class="vanSearch"
        v-model="searchText"
        show-action
        placeholder="请输入食物名称"
        shape="round"
        @search="onSearch"
        @input="searchInput"
        @focus="searchFocus"
        maxlength="60"
      >
        <template v-slot:left-icon>
          <img class="search-img" src="@/assets/images/icon/search.png" />
        </template>
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
    </div>

    <!-- 搜索结果 -->
    <div class="classified-food" v-show="!layerFloatShow">
      <van-list
        class="ex_question_list"
        v-model="searchLoading"
        :offset="10"
        :finished="searchFinished"
        :finished-text="finishText"
        :error.sync="searchError"
        error-text="请求失败，点击重新加载"
        @load="searchResultFn"
      >
        <!-- <listItem
          :list="searchResultList"
          @goFoodDetails="tosearchDetail"
        ></listItem> -->
        <listItem v-for="(item, index) in searchResultList" :key="index"
            @goFoodDetails="tosearchDetail"
            :item="item"
            :id="index">
            </listItem>
      </van-list>
    </div>
    <!-- 搜索内容不存在 -->
    <search-unfind
      :keyWord="searchText"
      :type="'eatPage'"
      v-show="!noContent"
    ></search-unfind>
    <!-- 返回顶部 -->
    <to-top></to-top>
  </div>
</template>

<style lang="less" scoped>
.searchOnlineSearch {
  min-height: 100%;
  background: #f7f7f7;
}
/deep/ .van-field__value {
  padding-left: 14px;
}
/deep/ .van-list__finished-text {
    padding: 12px 0;
    background: #f7f7f7;
}
.unfind {
  padding-top: 58px;
}
.search-img {
  width: 14px;
  position: absolute;
  top: 50%;
  margin-top: -9px;
}
.search_ {
  width: 100%;
  background: @expertFontColor255;
  overflow: hidden;
  padding-bottom: 12px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 98;
  .back {
    float: left;
    font-size: @indexFontSize20;
    padding-top: 19px;
    width: 22px;
    text-align: right;
    padding-left: 5px;
  }

  .van-search {
    width: 91%;
    padding: 12px 0 0 12px;
    font-size: @indexFontSize12;
    float: left;
    .van-search__action {
      padding: 0 12px;
      font-size: @indexFontSize14;
    }
    .van-field__control {
      line-height: 24px;
      padding-left: 2px;
    }
  }
  span.canBtn {
    height: 58px;
    width: 47px;
    line-height: 58px;
    display: inline-block;
    float: left;
    font-size: @indexFontSize14;
    color: @expertFontColor51;
    text-align: center;
  }
}
.classified-food {
  margin-top: 58px;
  background: #f7f7f7;
  padding: 10px 12px 13px;
}
.classified-list {
  margin-top: 56px;
}
</style>

<script>
import API from '@/utils/axiosApi/canEatApi';
import listItem from '@/views/canEatList/components/listItem.vue';
import layerFloat from '@/components/contents/expertOnline/expertRecord.vue';
import { fomatterNum, getCookie, Debounce } from '@/assets/js/common.js';
import searchUnfind from '@/components/common/unfind.vue';
import toTop from '@/components/common/toTop.vue';
import { uniqueArr } from '@/assets/js/common.js';
export default {
  name: 'searchOnlineSearch',
  components: {
    listItem,
    layerFloat,
    searchUnfind,
    toTop
  },
  data() {
    return {
      title: this.$route.query.title || '能不能吃',
      isHot: this.$route.query.isHot, //是否点击热词
      isHis: this.$route.query.isHis, //是否点击历史记录
      searchText: this.$route.query.searchText || '', //搜索词
      layerFloatShow: true, // 是否显示搜索结果
      searchResultList: [], //搜索列表
      searchResultParams: { size: 10, page: 1 }, //分页
      searchList: [], //搜索词的历史记录
      noContent: true, //是否有搜索内容
      searchLoading: false, //是否显示loading
      searchFinished: false, //是否加载完成
      finishText: '', //加载完成底部文字
      searchError: false // 是否显示错误提示
    };
  },
  mounted() {
    document.title = this.title;
    if (this.searchText !== '') {
      this.layerFloatShow = false;
    }
    this.initHistory();
  },
  methods: {
    fomatterNum,
    getCookie,
    Debounce,
    uniqueArr,
    // 根据搜索关键词搜索
    searchResultFn: Debounce(function() {
      if (this.searchText == '') return false;

      this.noContent = true;
      API.getSearchFood(
        {
          content: this.searchText,
          page: this.searchResultParams.page,
          size: this.searchResultParams.size
        },
        (res) => {
          this.searchLoading = false;
          if (res.code == 200) {
            this.searchResultList = this.searchResultList.concat(
              res.data.content
            );

            sensors.track('Eatable_ResultPage', {
              page_name: this.title,
              key_word: this.searchText,
              is_history: this.isHis,
              is_Hot_search: this.isHot,
              is_successful: true,
              search_number: this.searchResultList.length,
              module_name:'能不能吃',
              per_page_name:'能不能吃',
              per_module_name:'能不能吃'
            });

            if (
              this.searchResultParams.page >=
                Math.ceil(
                  res.data.totalElements / this.searchResultParams.size
                ) ||
              Math.ceil(
                res.data.totalElements / this.searchResultParams.size
              ) === 0
            ) {
              this.searchFinished = true;
              this.finishText = '——已经到底了哦——';
            } else {
              this.searchResultParams.page += 1;
            }
            if (
              this.searchResultParams.page == 1 &&
              res.data.content.length == 0
            ) {
              this.finishText = '';
              this.noContent = false;
            }
          } else {
            this.searchLoading = false;
            this.searchError = true;
            sensors.track('Eatable_ResultPage', {
              page_name: this.title,
              key_word: this.searchText,
              is_history: this.isHis,
              is_Hot_search: this.isHot,
              is_successful: false,
              search_number: 0,
              module_name:'能不能吃',
              per_page_name:'能不能吃',
              per_module_name:'能不能吃'
            });
          }
        },
        (res) => {
          this.searchLoading = false;
          this.searchError = true;
        }
      );
    }, 500),
    // 搜索
    onSearch: function() {
      sensors.track('Eatable_SentSearch', {
        page_name: this.title,
        key_word: this.searchText,
        is_history: false,
        is_Hot_search: false,
        module_name:'能不能吃',
        per_page_name:'能不能吃',
        per_module_name:'能不能吃'
      });
      if (this.searchText !== '') {
        this.searchLoading = true;
        this.searchFinished = false;
        this.searchResultList = [];
        this.layerFloatShow = false;
        this.searchResultParams.page = 1;
        this.searchResultFn();

        this.searchList.unshift(this.searchText);
        this.searchList = this.uniqueArr(this.searchList);
        if (this.searchList.length > 10) {
          this.searchList = this.searchList.slice(0, 10);
        }
        localStorage.setItem('eatSearchList', this.searchList.join(','));
      } else {
        this.$toast('请输入食物名称');
      }
    },
    // 获取本地搜索记录，初始化本地搜索记录
    initHistory() {
      var historyStr = '';

      if (
        localStorage.getItem('eatSearchList') &&
        localStorage.getItem('eatSearchList') !== ''
      ) {
        historyStr = historyStr + ',' + localStorage.getItem('eatSearchList');
        localStorage.removeItem('eatSearchList');
      }
      localStorage.setItem('eatSearchList', historyStr);
      historyStr.split(',').forEach((item) => {
        if (item == '') return;
        this.searchList.push(item);
      });
    },
    // 取消搜索
    onCancel: function() {
      this.searchText = '';
      this.layerFloatShow = true;
    },
    // 搜索框值发生改变
    searchInput: function() {
      this.noContent = true;
      
      if (this.searchText == '') {
        this.layerFloatShow = true;
        this.goBack();
      }
    },
    // 搜索框获取焦点
    searchFocus: function() {
      sensors.track('Eatable_ClickSearch', {
        page_name: this.title,
        module_name:'能不能吃',
        per_page_name:'能不能吃',
        per_module_name:'能不能吃'
      });
      if (this.searchText == '') {
        this.layerFloatShow = true;
      }
    },
    // 监听地址栏参数发生改变
    searchChange: function(val) {
      this.searchText = val;
      this.searchLoading = true;
      this.searchFinished = false;
      this.searchResultList = [];
      this.searchResultParams.page = 1;
      this.searchResultFn();
      this.layerFloatShow = false;
    },
    // 点击搜索列表埋点
    tosearchDetail: function(item, index) {
      sensors.track('Eatable_ClickSearchResult', {
        page_name: this.title,
        key_word: this.searchText,
        is_history: this.isHis,
        is_Hot_search: this.isHot,
        search_number: this.searchResultList.length,
        click_position: index + 1,
        module_name:'能不能吃',
        per_page_name:'能不能吃',
        per_module_name:'能不能吃'
      });
      const nape = document.getElementsByClassName('title')[index].innerText;
      setTimeout(() => {
        this.$router.push({
          path: '/canEatDetail/' + item,
          query: { nape: nape }
        });
      }, 200);
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
